import { composeUrlWithSearchParams, performRedirect } from '../redirect-helpers';
import { getShortTermToken } from '../../../authorisation-utils/sso-v1-utils/endpoints';
import Config from '../../config-manager';

const composeThirdPartyRedirectUrl = (url: string, shortTermToken: string, searchParams?: Record<string, string>): string => {
  return composeUrlWithSearchParams(url, {
    ...searchParams,
    [Config.get<string>('tp_redirect_url_search_params.token')]: shortTermToken,
  });
};

/**
 * Initiates SSO and performs a redirect to the given Third Party
 * @param redirectUrl
 * @param partnerCode
 * @param urlParams
 */
export const initiateThirdPartyRedirect = async (redirectUrl: string, partnerCode: string, urlParams?: Record<string, string>) => {
  const tokenResponse = await getShortTermToken(partnerCode);
  const token = tokenResponse.data?.token;
  if (tokenResponse.error || !token) {
    throw new Error('Failed to get short term token');
  }
  performRedirect(composeThirdPartyRedirectUrl(redirectUrl, token, urlParams));
};
